<script>
import CodeEditor from '@/components/form-controls/CodeEditor';
import Panel from '@/components/ui/Panel';

export default {
  name: 'VideoPanel',
  components: {
    CodeEditor,
    Panel
  },
  data() {
    return {
      editor: {},
      bookmark: null,
      video: null,
      code: ''
    };
  },
  methods: {
    show(options) {
      const editor = options.editor;
      const el = editor.getSelectedElement();
      this.bookmark = editor.getBookmark();
      this.editor = editor;
      this.video = el.closest('.cms-embed');
      this.code = this.video ? editor.getAttribute(this.video, 'data-source') : '';
      this.$refs.panel.show();
    },

    hide() {
      this.$refs.panel.hide();
      this.code = '';
    },

    deleteVideo() {
      this.$refs.panel.hide();
      this.editor.restoreBookmark(this.bookmark);
      this.editor.removeElement(this.video);
    },

    handleHide() {
      this.editor.focus();
    },

    handleShow() {
      this.$refs.codeEditor.focus();
    },

    handleSubmit() {
      const code = this.code.trim();

      this.$refs.panel.hide();
      this.editor.restoreBookmark(this.bookmark);
      if (code.match(/^https?:\/\//i)) {
        // Fetch oEmbed data
        this.$http.get('/utilities/oembed', {
          params: { url: code }
        })
          .then(res => this.editor.insertEmbed(res.data.oEmbed.html || code))
          .catch(() => this.editor.insertEmbed(code));
      } else {
        // Insert raw code
        this.editor.insertEmbed(code);
      }
    }
  }
};
</script>

<template>
  <panel
    ref="panel"
    :title="$t('Video')"
    @show="handleShow"
    @hide="handleHide"
  >
    <el-form
      label-position="top"
      novalidate
      @submit.native.prevent="handleSubmit"
    >
      <fieldset>
        <el-form-item :label="$t('Embed Code')">
          <code-editor
            ref="codeEditor"
            v-model="code"
            :allow-full-screen="false"
            :line-numbers="false"
            mode="html"
          />
          <div class="text-form-description">
            {{ $t('Copy and paste the video\'s URL or embed code here.') }}
          </div>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-button type="primary" native-type="submit">
              <span v-if="video">{{ $t('Update Video') }}</span>
              <span v-else>{{ $t('Insert Video') }}</span>
            </el-button>
          </el-col>
          <el-col :span="12" class="text-right">
            <el-button v-if="video" :title="$t('Delete Video')" @click="deleteVideo">
              <i class="el-icon-fa-trash" />
            </el-button>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
  </panel>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

//
// No styles yet
//

</style>
